import { Discount } from '../../components/steps/PaymentStep/paymentStep.types';

export const formatAmount = (amount: number) => (amount / 100).toFixed(0);
export const formatAmountUI = (amount: number) => Math.ceil(amount / 100);

export const amountToString = (amount: number, currency: string) => {
  return `${formatAmount(amount)}${currency}`;
};

export const calculateAmountWithDiscount = (amountInCents: number, discount: Discount | undefined | null) => {
  const amount =
    amountInCents * (1 - (discount?.coupon?.duration ? discount?.coupon?.percentOff : 0) / 100) -
    (discount?.coupon?.duration ? discount?.coupon?.amountOff : 0);
  return Math.round(amount);
};

export const calculatePurchasePrice = (priceInCents: number): number => {
  const priceInWholeUnits = Math.floor(priceInCents / 100);

  // Purchase event occur at start of trial, hence we reflect the mean price by dividing the price in 2
  return Math.floor(priceInWholeUnits / 2);
};
